export enum UploadDocumentType {
  PDF = "application/pdf",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  DOC = "application/msword",
  JPEG = "image/jpeg",
  JPG = "image/jpg",
  PNG = "image/png",
  PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  CSV = "text/csv",
}
